import { render, staticRenderFns } from "./TeacherInput.vue?vue&type=template&id=e729b036"
import script from "./TeacherInput.vue?vue&type=script&lang=js"
export * from "./TeacherInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports